import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OrderTimeline } from '../../components/widgets';
import { setIsTimelineUpdated } from '../../store/orders/actions';

export default withRouter(
  connect(
    (state, ownProps) => {
      const { ordersState, basicOrderState, mapState } = state;
      const { orderInfo } = basicOrderState;
      const { isShowShimmer } = ordersState;
      const { mapData } = mapState;
      const { orderId } = ownProps;
      const orderBasicInfo =
        orderId && orderInfo && orderInfo[orderId] ? orderInfo[orderId] : null;
      const isClubbedOrder =
        orderId && mapData && mapData[orderId]
          ? mapData[orderId].is_clubbed_order
          : false;
      return {
        orderId,
        isShowShimmer,
        orderBasicInfo,
        isClubbedOrder,
      };
    },
    (dispatch) => {
      return {
        setIsTimelineUpdated: (data) => dispatch(setIsTimelineUpdated(data)),
      };
    },
  )(OrderTimeline),
);
